import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyC0Mg2LHi0AkDiM9E7Oh0E0c8eBbqFk20E",
  authDomain: "prof-web-b0ecb.firebaseapp.com",
  databaseURL: "https://prof-web-b0ecb-default-rtdb.firebaseio.com",
  projectId: "prof-web-b0ecb",
  storageBucket: "prof-web-b0ecb.firebasestorage.app",
  messagingSenderId: "252065777849",
  appId: "1:252065777849:web:6ac18c280c46fe952c7368",
  measurementId: "G-ZNYJR423T0"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);